export default __webpack_public_path__ + "static/media/PS.169f6a96.svg";